import clsx from 'clsx'
import { Loader2 } from 'lucide-react'

const variants = {
  primary: 'relative overflow-hidden bg-gradient-to-br from-blue to-[#2f6fd6] text-white shadow-glow hover:brightness-110 active:brightness-95',
  ghost: 'bg-panel2 text-ink border border-line hover:border-line-strong hover:border-sky/40',
  danger: 'bg-danger text-white hover:brightness-110',
  subtle: 'bg-transparent text-muted hover:text-ink hover:bg-panel2'
}

const sizes = {
  sm: 'h-9 px-3 text-[13px] gap-1.5',
  md: 'h-11 px-4 text-[14px] gap-2',
  lg: 'h-12 px-5 text-[15px] gap-2'
}

export default function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  icon: Icon,
  className,
  children,
  ...props
}) {
  return (
    <button
      disabled={disabled || loading}
      className={clsx(
        'inline-flex items-center justify-center font-semibold rounded-md transition-all duration-200 ease-out',
        'disabled:opacity-40 disabled:cursor-not-allowed',
        'active:scale-[0.98]',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {variant === 'primary' && (
        <span className="pointer-events-none absolute inset-x-0 top-0 h-1/2 rounded-t-md bg-[image:var(--btn-highlight)] z-0" />
      )}
      <span className="relative z-10 inline-flex items-center gap-2">
        {loading ? <Loader2 className="animate-spin" size={16} /> : Icon ? <Icon size={16} /> : null}
        {children}
      </span>
    </button>
  )
}
